import { useState } from 'react';
import ReactCheckboxTree from 'react-checkbox-tree';
import { getAllExpanded } from '../../helpers/checkbox-tree';
import { IFormItemProps } from '../../types/components/form';
import { ICheckboxTreeLayout } from '../../types/layout/checkbox-tree';

function CheckboxTree({
    data, disabled, noCascade, value, onChange,
}: ICheckboxTreeLayout & IFormItemProps) {
    const [expanded, setExpanded] = useState<string[]>(getAllExpanded(data));

    return (
        <ReactCheckboxTree
            disabled={disabled}
            nodes={data || []}
            icons={{
                expandOpen: <i className="fa-solid fa-angle-down checkbox-tree-arrow" />,
                expandClose: <i className="fa-solid fa-angle-right checkbox-tree-arrow" />,
            }}
            showNodeIcon={false}
            checked={value}
            onCheck={onChange}
            expanded={expanded}
            onExpand={setExpanded}
            noCascade={noCascade}
            nativeCheckboxes
        />
    );
}

export default CheckboxTree;
